export const SUBSCRIPTIONS = 'SUBSCRIPTIONS';
export const ORDERS = 'ORDERS';
export const PARTNER_INFO = 'PARTNER_INFO';
export const COMMERCE = 'COMMERCE'; // activated by trigger
export const COMMERCE_ON_DEMAND = 'COMMERCE_ON_DEMAND'; // activate by click
